export default __webpack_public_path__ + "static/media/volume_off_black_24dp.a74305d6.svg";